import React from 'react'
import PropTypes from 'prop-types'
import PrivacyEn from './PrivacyEn'
import PrivacyDe from './PrivacyDe'
import { useParams } from 'react-router-dom'

const Privacy = ({
  children = null,
}) => {
  const { languageId } = useParams();

  return (
    <>
      <div className="w-full">
        <div className="max-w-7xl mx-auto sm:px-6 lg:px-8">
          { (languageId === 'en') ? 
            (<PrivacyEn />)
            : (<></>)
          }
          { (languageId === 'de') ? 
            (<PrivacyDe />)
            : (<></>)
          }
        </div>
      </div>
      {children}
    </>
  )
}

Privacy.propTypes = {
  children: PropTypes.any,
}

export default Privacy
